
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 48.866 53.477"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"clip-path-studio-mode"}},[_c('rect',{attrs:{"id":"Rectangle_12790","data-name":"Rectangle 12790","width":"48.866","height":"53.477","fill":"none"}})])]),_c('g',{attrs:{"id":"Group_40314","data-name":"Group 40314"}},[_c('g',{attrs:{"id":"Group_40313","data-name":"Group 40313","clip-path":"url(#clip-path-studio-mode)","fill":"#d9d9d9"}},[_c('path',{attrs:{"id":"Path_28947","data-name":"Path 28947","d":"M35.5 0a13.36 13.36 0 00-13.013 10.365H26.3a4.7 4.7 0 014.694 4.694v10.874A13.36 13.36 0 1035.5 0"}}),_c('path',{attrs:{"id":"Path_28948","data-name":"Path 28948","d":"M23.83 30.277a4.709 4.709 0 014.07-2.348c.032 0 .063.006.095.007V15.059a1.7 1.7 0 00-1.695-1.695H1.694A1.694 1.694 0 000 15.059v24.6a1.694 1.694 0 001.694 1.695h15.74z"}}),_c('path',{attrs:{"id":"Path_28949","data-name":"Path 28949","d":"M30.991 34.6l-1.5-2.6-.128-.221a1.666 1.666 0 00-1.372-.836c-.032 0-.063-.012-.095-.012a1.679 1.679 0 00-1.468.848L20.9 41.356l-.867 1.5-.865 1.5-3.8 6.579a1.7 1.7 0 001.468 2.542h22.12a1.7 1.7 0 001.468-2.542z"}})])])])
          )
        }
      }
    